<template>
  <dashboard-tile
    :amount="number(item.amount)"
    :extraModifiers="classnameModifiers"
    :name="item.display_name"
    :previous-amount="number(item.previous_amount)"
    :type="item.type"
  />
</template>

<script>
  import DashboardTile from '@/components/DashboardTile'

  import { bem } from '@/mixins/bem.js'
  import { helpers } from '@/mixins/helpers.js'

  const namespace = 'product-dashboard-item'

  export default {
    name: 'ProductDashboardItem',
    components: {
      'dashboard-tile': DashboardTile
    },
    mixins: [ bem, helpers ],
    props: {
      hide: {
        default: false,
        type: Boolean
      },
      item: {
        type: Object
      }
    },
    created: function () {
      this.setNamespace(namespace)
    },
    methods: {
      classnameModifiers: function () {
        const hide = this.hide ? 'hide' : 'show'

        return [
          hide
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/components/ProductDashboardItem.vue